import { render, staticRenderFns } from "./ImageCollection.vue?vue&type=template&id=7b71a069&scoped=true&"
import script from "./ImageCollection.vue?vue&type=script&lang=js&"
export * from "./ImageCollection.vue?vue&type=script&lang=js&"
import style0 from "./ImageCollection.vue?vue&type=style&index=0&id=7b71a069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71a069",
  null
  
)

export default component.exports